<template>
  <div class="safe-box">
    <div class="title">领取{{ safeType == 0 ? '返水' : '外水' }}</div>
    <van-form @submit="onSubmit" ref="frm">
      <div style="text-align: left; color: green; margin-bottom: 8px;text-indent: 14px;">
        可领取：{{ parseFloat(safeBanlance).toFixed(2) }}
      </div>
      <van-field
        v-model="frm.pay_pass"
        type="password"
        label="资金密码"
        placeholder="请填写资金密码"
        :rules="[{ required: true, message: '请填写资金密码' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >确认领取</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: 'FanShuiGetBox',
  props: ['type', 'banlance','bustype'],
  computed: {
    safeBusType(){
      return this.bustype || 0
    },
    safeType () {
      return this.type || 0
    },
    safeBanlance () {
      return this.banlance || 0
    }
  },
  data () {
    return {
      frm: {
        // amount: null,
        pay_pass: null
      }
    }
  },
  methods: {
    formatter(value){
      const decimalRegex = /(\.\d{2})\d+/
      return value.replace(decimalRegex, '$1');
    },
    onSubmit () {
      if (this.safeType == 0) this.GetclaimFanshui()
      if (this.safeType == 1) this.GetclaimOutFanshui()
    },
    async GetclaimOutFanshui () {
      await this.$http({
        method: 'post',
        url: 'claimOutFanshui',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.$emit('closep2')
        }
      })
    },
    async GetclaimFanshui () {
      await this.$http({
        method: 'post',
        url: 'claimFanshui',
        data: this.frm
      }).then(data => {
        if (data && data.code == 200) {
          this.$toast.success(data.msg)
          this.$emit('closep2')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.safe-box {
  margin: 10px;
  padding: 10px;
  width: 80vw;
  .title {
    height: 38px;
    line-height: 38px;
    color: #000;
  }
}
</style>
